const getters = {
  // bottleY: state => state.bottle.bottleY,
  lang: state => state.i18n.lang,
};
export default getters;
